const buyerGeneratePDF = (data) => {

  let fatfImageUrl = "https://statics.moglix.com/img/newsletter/int/2025/Jun/240625/1/RiskMid.png"; // default Yellow
  if (data.countryFATFStatus.includes("Green")) {
    fatfImageUrl = "https://statics.moglix.com/img/newsletter/int/2025/Jun/240625/1/green.png"; // Green image
  } else if (data.countryFATFStatus.includes("Red")) {
    fatfImageUrl = "https://statics.moglix.com/img/newsletter/int/2025/Jun/240625/1/Risklow.png"; // Red image
  }

  
  let riskMeter = "https://statics.moglix.com/img/newsletter/int/2025/Jun/030625/1/veryHighRisk.png"; // Very High Risk
  if (data.riskAssessment.includes("Very Low Risk")) {
    riskMeter = "https://statics.moglix.com/img/newsletter/int/2025/Jun/030625/1/veryLowRisk.png"; // Very Low Risk
  } else if (data.riskAssessment.includes("Low Risk")) {
    riskMeter = "https://statics.moglix.com/img/newsletter/int/2025/Jun/030625/1/lowRisk.png"; // Low Risk
  } else if (data.riskAssessment.includes("Moderate Risk")) {
    riskMeter = "https://statics.moglix.com/img/newsletter/int/2025/Jun/030625/1/moderateRisk.png"; // Moderate Risk
  } else if (data.riskAssessment.includes("High Risk")) {
    riskMeter = "https://statics.moglix.com/img/newsletter/int/2025/Jun/030625/1/highRisk.png"; // High Risk
  }
  let fATFStatus = data.countryFATFStatus.replace(/^Status:\s*/i, '');

  let showPaymetTrackRecord = data.estimatedBuyerRevenue;

  let greenTick = "";
   if (data.riskAssessment.includes("Very Low Risk") || data.riskAssessment.includes("Low Risk")) {
   greenTick = "https://statics.moglix.com/img/newsletter/int/2025/Jun/240625/1/checkbox-circle-fill.png";
  }
  

  return `
  <!DOCTYPE html>
  <html lang="en">
   <head>
      <title>Buyer assessment report</title>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
       <style>
         @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;700&display=swap');
         body, table, td, p, span, div {
           font-family: 'Rubik', Arial, sans-serif !important;
         }
       </style>
   </head>
   <body style="margin: 0; padding: 15px; background-color: #f5f5f5;">
      <table cellpadding="0" cellspacing="0" width="100%"
         style="font-family: Arial, sans-serif; background: #fff;">
         <tr>
            <td style="padding: 0px 20px;">
               <table width="100%">
                  <tr>
                     <td align="left">
                        <a href="https://www.credlix.com/" target="_blank" rel="noopener noreferrer">
                        <img src="https://statics.moglix.com/img/newsletter/int/2025/Jun/300625/1/buyerLogo.png" alt="credlix" width="84" style="height: auto;">
                        </a>
                     </td>
                     <td align="right" style="font-size: 14px; font-weight: 400; color: #000000;">
                        Reference ID: ${data.referenceId}
                     </td>
                  </tr>
               </table>
            </td>
         </tr>
         <table style="max-width: 100%; margin: auto; border: 1px solid #D7D7DC; border-collapse: collapse;">
            <tr>
               <td>
                  <img src="https://statics.moglix.com/img/newsletter/int/2025/Jun/300625/1/BuyerBannern.png" alt="txt"
                     style="width: 100%; display: block; height: auto;">
               </td>
            </tr>
            <tr>
               <td style="padding: 20px 20px 5px 20px">
                  ${data.buyerName ? `
                  <h2 style="margin: 0; color: #072F5F; font-size: 24px; font-weight: 500;">${data.buyerName}</h2>
                  ` : ''}
                  ${data.address ? `
                  <p style="margin: 2px 0 0; font-size: 14px; color: #3C3C3C; line-height: 20px; font-weight: 400;">${data.address}</p>
                  ` : ''}
               </td>
            </tr>
            <tr>
               <td style="padding: 20px;">
                  <h3 style="font-weight: 500; color: #072F5F; font-size: 16px; padding-bottom: 10px; margin: 0;">About Buyer</h3>
                  <p style="color: #3C3C3C; font-size: 16px; line-height: 20px; font-weight: 400; margin: 0;">${data.briefOnBuyer} 
                  </p>
               </td>
            </tr>
            <!-- Country Assessment Yellow -->
            <tr>
               <td>
                  <table width="100%" cellpadding="20" cellspacing="10" style="padding: 13px;">
                     <tr>
                        <td rowspan="2" valign="top" style="border: 1px solid #086AC9; border-radius: 5px; width: 50%;">
                           <h3 style="margin: 0 0 10px; font-size: 16px; color: #072F5F;">Buyer Industry & Risk Assessment</h3>
                           <p style="margin: 10px 0; font-size: 14px; color: #6F6F6F;">Industry : <span style="color: #3C3C3C; font-weight: 500; margin-left: 5px;"> ${data.industry}</span></p>
                           <p style="margin: 10px 0; font-size: 14px; color: #6F6F6F;">Risk Assessment : <span style="color: #3C3C3C; font-weight: 500; margin-left: 5px;"> ${data.riskAssessment} ${greenTick ? `<img src="https://statics.moglix.com/img/newsletter/int/2025/Jun/240625/1/checkbox-circle-fill.png" alt="Correct Meter" width="100%" style="width: 20px; height: 20px; margin-left: 4px; vertical-align: middle;" />` : ''} </span> </p>
                           ${showPaymetTrackRecord ? `
                           <p style="margin: 10px 0; font-size: 14px; color: #6F6F6F;">Estimated Buyer Revenue : <span style="color: #3C3C3C; font-weight: 500; margin-left: 5px;"> ${data.estimatedBuyerRevenue}</span></p>
                           `:''}
                           <div style="margin-top: 24px; width: 100%;">
                              <img src=${riskMeter} alt="Risk Meter" style="width: 48%; padding: 0px 20px 0px 0px; display: inline-block; vertical-align: middle; box-sizing: border-box;" />
                              ${data.bankruptcyStatus === true ? `<img src="https://statics.moglix.com/img/newsletter/int/2025/August/120825/1/banckruptynew.png" alt="Bank" style="padding: 0px 20px 0px 0px; display: inline-block; vertical-align: middle; box-sizing: border-box;" />`:''}
                           </div>
                        </td>
                        <td style="padding: 0px 5px; width: 50%; border: 1px solid #086AC9; border-radius: 5px; padding: 20px; box-sizing: border-box;">
                           <h3 style="margin: 0 0 10px; font-size: 16px; color: #072F5F;">Country Assessment</h3>
                          ${data.country ? ` <p style="margin: 10px 0; font-size: 14px; color: #6F6F6F;">Country : <span style="color: #3C3C3C; font-weight: 500; margin-left: 5px;"> ${data.country}</span></p> ` : ''}
                           <p style="margin: 10px 0; font-size: 14px; color: #6F6F6F;">Country Assessment : <span style="color: #3C3C3C; font-weight: 500; margin-left: 5px;"> ${data.countryRagStatus} </span> </p>
                           <p style="margin: 10px 0; font-size: 14px; color: #6F6F6F;">FATF Status :<span style="color: #3C3C3C; font-weight: 500; margin-left: 5px;"> ${fATFStatus} </span></p>
                           <div style="margin-top: 15px;">
                              <img src=${fatfImageUrl} alt="FATF Score Bar" width="100%" style="max-width: 250px;" />
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td style="width: 50%; border: 1px solid #086AC9; border-radius: 5px; padding: 20px; box-sizing: border-box; background-color: #F0FFF0;">
                           <h3 style="margin: 0; font-size: 16px; color: #072F5F;">Maximum Credit Recommendation</h3>
                           ${data.creditRecommendation ? `<p style="margin: 5px 0; font-size: 16px; color: #059A6D; font-weight: 500; line-height: 20px;">USD: ${data.creditRecommendation}</p>`:''}

                           ${data.creditRecommendationMessage 
                              ? `<p style="margin: 0px 0 0; font-size: 14px; font-weight: 500; color: ${data.creditRecommendationMessage === 'Buyer exhibits high credit worthiness' ? '#000000' : '#D9232D'}; line-height: 20px;">${data.creditRecommendationMessage}</p>` 
                              : ''}
                           <p style="margin: 0px 0 0; font-size: 12px; color: #3C3C3C; font-weight: 400; line-height: 20px;"> Based on 60 days open payment terms. </p>
                           <p style="margin: 10px 0 0; font-size: 12px; color: #6F6F6F; font-weight: 400;">
                              This amount is a commercial credit limit guide and is not written through the Credlix underwriting centers. Unless there is a specific contractual agreement, the commercial credit limit cannot be considered as a credit insurance guarantee by Credlix. If higher limits are required then please reach out to us.
                           </p>
                        </td>
                     </tr>
                  </table>
               </td>
            </tr>
            <tr>
               <td align="center" valign="top">
                  <span style="font-weight: 500; font-size: 16px; color: #000000; font-family: Arial, sans-serif; margin: 20px 0; display: block;">
                  Got a query? Reach out to
                  <a
                     href="mailto:enquiry@credlix.com"
                     target="_blank"
                     rel="noopener noreferrer"
                     style="text-decoration: none; color: #086AC9; font-weight: 500;"
                     >
                  enquiry@credlix.com
                  </a>
                  </span>
               </td>
            </tr>
            <tr>
               <td style="margin:10px; padding: 20px;">
                  <a href="https://www.credlix.com/"
                     target="_blank" rel="noopener noreferrer">
                  <img src="https://statics.moglix.com/img/newsletter/int/2025/Jun/300625/1/BannerExport.png" alt="txt"
                     style="width: 100%; display: block; height: auto;">
                  </a>
               </td>
            </tr>
            <tr>
               <td style="width: 100%; padding: 10px 20px;">
                  <p style="padding: 10px 0; font-size: 16px; font-weight: 500; margin: 0; color: #072F5F;">Terms of Use</p>
                  <p style="padding: 5px 0; font-size: 12px; margin: 0; color: #6F6F6F;">The information and/or data provided in this report are subject to the General Terms and Conditions or individual Contract Terms and may be used only for the purpose they have been requested for. The information contained in this report is based on data provided by an external business information provider, with the exception of “Credlix Adjustment” which comes from Credlix’s Credit Insurance activity.</p>
                  <p style="padding: 5px 0; font-size: 12px; margin: 0;  color: #6F6F6F;">The Maximum Credit Recommendation contained in this report is not a formal credit limit decision issued by an empowered Credit insurance Risk underwriter and any unpaid amount on a debtor would not qualify as a claim under a credit insurance policy.</p>
                  <p style="padding: 4px 0; font-size: 12px; margin: 0; color: #6F6F6F;">As the recipient of the information report, you are bound by a duty of confidentiality. You shall keep the information included therein strictly confidential, not use it in any way that would bring it into the public domain, and avoid its disclosure.</p>
                  <p style="padding: 5px 0; font-size: 12px; margin: 0; color: #6F6F6F;">The report may contain personal data. You undertake to respect and comply with all applicable legislation on personal data protection regarding all personal data which may be contained in this report. You remain liable to implement all appropriate measures ensuring the protection, safety, and confidentiality of the personal data contained in this report and to prevent it from being distorted, damaged, or communicated to unauthorized third parties in accordance with the applicable law.</p>
                  <p style="padding: 10px 0; font-size: 12px; margin: 0; color: #6F6F6F;">You shall be liable for any of your acts and omissions relating to the above-mentioned obligations that result in a breach of personal data protection.</p>
                  <p style="padding: 0px 0 15px 0; font-size: 12px; margin: 0; color: #6F6F6F;">Thank you for using Credlix services. If you have any questions, please get in touch with your usual Customer Service Contact.</p>
               </td>
            </tr>
         </table>
      </table>

      <div style="page-break-before: always;"></div>
      
      <!-- 2nd Page -->
      <table cellpadding="0" cellspacing="0" width="100%"
         style="font-family: Arial, sans-serif; background: #fff;">
         <tr>
            <td style="padding: 24px 20px 0px 20px;">
               <table width="100%">
                  <tr>
                     <td align="left">
                        <a href="https://www.credlix.com/" target="_blank" rel="noopener noreferrer">
                        <img src="https://statics.moglix.com/img/newsletter/int/2025/Jun/300625/1/buyerLogo.png" alt="credlix" width="84" style="height: auto;">
                        </a>
                     </td>
                     <td align="right" style="font-size: 14px; font-weight: 400; color: #000000;">
                        Reference ID: ${data.referenceId}
                     </td>
                  </tr>
               </table>
            </td>
         </tr>
         <table style="max-width: 100%; width: 100%; border: 1px solid #D7D7DC; border-collapse: collapse;">
            <tr>
               <td>
                  <img src="https://statics.moglix.com/img/newsletter/int/2025/Jun/300625/1/BuyerBannern.png" alt="txt"
                     style="width: 100%; display: block; height: auto;">
               </td>
            </tr>
            <tr>
               <td style="padding: 0px 20px; margin-top: 40px; display: block;">
                  <p style="font-size: 16px; color: #072F5F; font-weight: 500;">
                     Duration: Last 6 months
                  </p>
                  <h3 style="margin-top: 10px; font-size: 24px; font-weight: 500; color: #072F5F;">Shipment Report</h3>
               </td>
            </tr>
            <tr>
               <td style="padding: 0px 20px 20px 16px;">
                  <table width="100%" cellpadding="20" cellspacing="10">
                     <tr>
                        <!-- Shipments -->
                        <td style="width: 32%; border: 1px solid #086AC9; border-radius: 5px; padding: 10px 20px; box-sizing: border-box;">
                           <span style="font-size: 16px; color: #072F5F; font-weight: 500;">
                           <img src="https://statics.moglix.com/img/newsletter/int/2025/July/310725/1/truck-duotone.png"
                              alt="truck"
                              style="width: 24px; height: auto; vertical-align: middle; display: inline-block; margin-right: 3px;">
                           <span style="display: inline-block; vertical-align: middle;">Shipments</span>
                           </span>
                           <p style="font-size: 20px; margin: 8px 0 0; color: #3C3C3C; font-weight: 500;">${data.noOfShipments}</p>
                        </td>
                        <!-- Value (USD) -->
                        <td style="width: 32%; border: 1px solid #086AC9; border-radius: 5px; padding: 10px 20px; box-sizing: border-box;">
                           <span style="font-size: 16px; color: #072F5F; font-weight: 500;">
                           <img src="https://statics.moglix.com/img/newsletter/int/2025/July/310725/1/currency-dollar.png"
                              alt="value"
                              style="width: 22px; height: auto; vertical-align: middle; display: inline-block;">
                           <span style="display: inline-block; vertical-align: middle;">Value (USD)</span>
                           </span>
                           <p style="font-size: 20px; margin: 8px 0 0; color: #3C3C3C; font-weight: 500;">${data.value}</p>
                        </td>
                        <!-- Volume (TEU) -->
                        <td style="width: 32%; border: 1px solid #086AC9; border-radius: 5px; padding: 10px 20px; box-sizing: border-box;">
                           <span style="font-size: 16px; color: #072F5F; font-weight: 500;">
                           <img src="https://statics.moglix.com/img/newsletter/int/2025/July/310725/1/shipping-container.png"
                              alt="volume"
                              style="width: 24px; height: auto; vertical-align: middle; display: inline-block; margin-right: 3px;">
                           <span style="display: inline-block; vertical-align: middle;">Volume (TEU)</span>
                           </span>
                           <p style="font-size: 20px; margin: 8px 0 0; color: #3C3C3C; font-weight: 500;">${data.volume}</p>
                        </td>
                     </tr>
                  </table>
               </td>
            </tr>
         </table>

          <table style="max-width: 100%; width: 100%; border: 1px solid #D7D7DC; border-collapse: collapse;">
            <tr>
               <td>
                  <table width="100%" cellpadding="20" cellspacing="10" style="padding:0px 20px 20px 20px;">
                     <h3 style="margin: 40px 0px 10px 0px; padding: 0px 20px; font-size: 24px; font-weight: 500; color: #072F5F;">Origin Country/Region</h3>
                     <!-- Shipments -->
                      ${data.countryShipmentShare.map((country) => `
                       <td style="width: 32%; border: 1px solid #086AC9; border-radius: 5px; padding: 12px 20px; box-sizing: border-box;">
                       <span style="font-size: 16px; color: #072F5F; font-weight: 500;">${country.name}</span>
                       <p style="font-size: 20px; margin: 10px 0 0; color: #3C3C3C; font-weight: 500;">${country.count} shipments (${country.percentage})</p>
                       </td>`
                      ).join("")}
                  </table>
            </td>
            </tr>
          </table>

         <table style="max-width: 100%; width: 100%; margin: auto;">
            <tr>
               <td align="center" valign="top">
                  <span style="font-weight: 500; font-size: 16px; color: #000000; font-family: Arial, sans-serif; margin: 60px 20px 0 0; display: block;">
                  Got a query? Reach out to
                  <a
                     href="mailto:enquiry@credlix.com"
                     target="_blank"
                     rel="noopener noreferrer"
                     style="text-decoration: none; color: #086AC9; font-weight: 500;"
                     >
                  enquiry@credlix.com
                  </a>
                  </span>
               </td>
            </tr>
            <tr>
               <td style="margin:10px; padding: 20px;">
                  <a href="https://www.credlix.com/"
                     target="_blank" rel="noopener noreferrer">
                  <img src="https://statics.moglix.com/img/newsletter/int/2025/July/310725/1/frieght.jpeg" alt="txt"
                     style="width: 100%; display: block; height: auto;">
                  </a>
               </td>
            </tr>
            <tr>
               <td style="margin:10px; padding: 0px 20px;">
                  <a href="https://www.credlix.com/"
                     target="_blank" rel="noopener noreferrer">
                  <img src="https://statics.moglix.com/img/newsletter/int/2025/July/310725/1/machinery.jpeg" alt="txt"
                     style="width: 100%; display: block; height: auto;">
                  </a>
               </td>
            </tr>
            <tr>
               <td style="margin:10px; padding: 20px;">
                  <a href="https://www.credlix.com/"
                     target="_blank" rel="noopener noreferrer">
                  <img src="https://statics.moglix.com/img/newsletter/int/2025/July/310725/1/globalGrowth.jpeg" alt="txt"
                     style="width: 100%; display: block; height: auto;">
                  </a>
               </td>
            </tr>
         </table>
      </table>
   </body>
</html>
`;
};

export default buyerGeneratePDF;
